import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  liveSubjectData: [],
  totalliveSubject: 0,
  isOpenModal: false,
}

export const liveSubjectSlice = createSlice({
  name: "liveSubject",
  initialState,
  reducers: {
    setliveSubjectData(state, { payload }) {
      state.liveSubjectData = payload.result
      state.totalliveSubject = payload.count
    },
    updateliveSubjectData(state, { payload }) {
      const objIndex = state.liveSubjectData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.liveSubjectData[objIndex] = payload
      }
    },
    deleteliveSubjectData(state, { payload }) {
      const objIndex = state.liveSubjectData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.liveSubjectData.splice(objIndex, 1)
      }
    },
    pushliveSubjectData(state, { payload }) {
      state.liveSubjectData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setliveSubjectData, updateliveSubjectData, deleteliveSubjectData, pushliveSubjectData, isOpenModal,
  ModalToggle } = liveSubjectSlice.actions;

export default liveSubjectSlice.reducer;

export function getliveSubject(limit, offset, ) {
  return async function getliveSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getliveSubject(limit, offset, ).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setliveSubjectData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addliveSubject(payload) {
  return async function addliveSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addliveSubject(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushliveSubjectData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateliveSubject(id, name) {
  return async function updateliveSubjectThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateliveSubject(id, name).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateliveSubjectData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}


export function deleteLiveSubject(id) {
  return async function deleteLiveSubjectThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteLiveSubject(id).then(
        (response) => {
          dispatch(deleteliveSubjectData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



